import { Loader2, TriangleAlert } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

interface PersonaCreatingDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	status: 'creating' | 'failed';
	errorMessage?: string | null;
}

export function PersonaCreatingDialog({ open, onOpenChange, status, errorMessage }: PersonaCreatingDialogProps) {
	const isFailed = status === 'failed';

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent
				showCloseButton={false}
				className='max-w-sm gap-0 rounded-3xl border-gray-500 bg-white/80 p-0 shadow-[0px_3px_12px_0px_rgba(0,0,0,0.08)] backdrop-blur-[6px]!'
			>
				<div className='flex w-full flex-col items-start gap-3 px-5 pt-4 pb-5'>
					<div className='flex w-full flex-col items-start justify-center gap-1.5'>
						{isFailed ? (
							<TriangleAlert className='size-7 text-destructive' />
						) : (
							<Loader2 className='size-7 animate-spin text-ink-strong' />
						)}
						<DialogTitle className='text-base leading-6 font-medium text-ink-strong'>
							{isFailed ? "Couldn't generate persona" : 'Creating Persona'}
						</DialogTitle>
					</div>
					<DialogDescription className='w-full text-[13px] leading-[18px] font-normal text-ink'>
						{isFailed
							? (errorMessage ?? "We were unable to generate the persona as there weren't enough tickets.")
							: "We're currently using your past tickets to implement the requested Persona."}
					</DialogDescription>
				</div>
				<DialogFooter className='w-full flex-row items-center justify-end p-3'>
					<Button className='h-8 rounded-full px-4 text-[13px] leading-[18px] font-normal' onClick={() => onOpenChange(false)}>
						Okay
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}
